import { getWebPath } from '@doss/common-all'
import { Settings } from 'lucide-react'
import { Link, useSearchParams } from 'react-router'
import { BreadcrumbObjectType } from '~/common/generated/apollo-operations'

interface FormMenuProps {
  formId: string
}

/**
 * Form menu actions - routes to form settings page.
 */
export function FormMenu({ formId }: FormMenuProps) {
  const [searchParams] = useSearchParams()
  const currentVariantId = searchParams.get('variant') ?? undefined

  return (
    <Link
      className="flex cursor-pointer items-center justify-center rounded p-2 hover:bg-gray-2"
      onClick={(e) => e.stopPropagation()}
      to={getWebPath({
        objectType: BreadcrumbObjectType.FORM,
        objectId: formId,
        settings: true,
        variantId: currentVariantId,
      })}
    >
      <Settings size={16} />
    </Link>
  )
}
